import { useLanguage } from '../context/LanguageContext';

export const LanguageSwitcher = ({ variant = 'default' }) => {
  const { language, toggleLanguage } = useLanguage();

  if (variant === 'footer') {
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={() => toggleLanguage()}
          className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
            language === 'en' 
              ? 'bg-[#1E88E5] text-white' 
              : 'bg-[#E2E8F0] text-[#334155] hover:bg-[#CBD5E1]'
          }`}
          data-testid="lang-en-footer"
        >
          EN
        </button>
        <button
          onClick={() => toggleLanguage()}
          className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
            language === 'es' 
              ? 'bg-[#1E88E5] text-white' 
              : 'bg-[#E2E8F0] text-[#334155] hover:bg-[#CBD5E1]'
          }`}
          data-testid="lang-es-footer"
        >
          ES
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#F1F5F9] hover:bg-[#E2E8F0] transition-colors text-sm font-medium text-[#334155]"
      data-testid="language-switcher"
      title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
    >
      <span className="text-base">{language === 'en' ? '🇺🇸' : '🇲🇽'}</span>
      <span>{language === 'en' ? 'EN' : 'ES'}</span>
    </button>
  );
};

export default LanguageSwitcher;
